module.exports = __webpack_public_path__ + "static/DSC_9335-866be1ece1ac6b916505ea5993b2e1e1.jpg";